module.exports = __webpack_public_path__ + "static/media/bg-blog-healthy.b1bc0ed0.png";